import { createStore } from "vuex";
import timer from "./modules/timer";
import modals from "./modules/modals";
import auth from "./modules/auth";
import loader from "./modules/loader";
import supervision from "./modules/supervision"

export default createStore({
  modules: {
    timer,
    modals,
    auth,
    loader,
    supervision
  },
});
